/* eslint-disable react/prop-types */
import React from "react";
import { useRouter } from "next/router";
import { Button } from "@/components/ui/button";

export default function ErrorFallBack({ error }) {
const router = useRouter();

  return (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <p className="fs-18 text-[var(--text-200)] font-bold mb-4">
        Sorry, Something went wrong.{" "}
      </p>
      <p className="fs-16 text-[var(--text-300)]"> {error?.message} </p>
      <div className="max-w-max mt-16">
      <Button
      onClick={() => {
        return router.back();
      }}
      className="text-[1.4rem] py-7 px-8 rounded-xl"
      >
        Go Back 
      </Button>
      </div>
    </div>
  );
}
